import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import mockData from '../mock';

const FAQSection = () => {
  const { faq } = mockData;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about rooftop solar and subsidy
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faq.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl border-2 border-orange-200 px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left text-lg font-bold text-gray-900 hover:text-orange-600 py-6">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 text-base leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still have questions CTA */}
        <div className="mt-12 text-center bg-gradient-to-r from-orange-500 to-yellow-400 rounded-2xl p-8 shadow-2xl">
          <h3 className="text-2xl font-bold text-white mb-2">
            Still Have Questions?
          </h3>
          <p className="text-orange-100 mb-6">
            Our solar experts are here to help you make the best decision
          </p>
          <a
            href="tel:+919937526689"
            className="inline-block bg-white text-orange-600 font-bold px-8 py-4 rounded-xl hover:bg-blue-50 transition-colors shadow-lg"
          >
            Talk to Our Expert Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;